import { cx } from '@linaria/core';
import { useContext } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { makeNotifierProvider, StoreContext } from '@provider/notifier';
import { DialogContainer, FocusOn, CloseButton, Link, Button } from '@ui/kit';
import { IsomorphicPortal, useObservedValue, CSSRefTransition } from '@utils/react';
import { transitionDurationMs, wrapper, content, heading, body, backdrop, actionsList } from './integration.notifier.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const CourseBuilderPanelNotifier = makeNotifierProvider({
  name: "course-builder-panel",
  ui: {
    Dialogs: () => /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(SlideUpDialogContainer, {}), /*#__PURE__*/jsx(IsomorphicPortal, {
        children: /*#__PURE__*/jsx(DialogContainer, {})
      })]
    })
  }
});
function SlideUpDialogContainer() {
  const store = useContext(StoreContext);
  const dialogs = useObservedValue(store.refs.dialogs).filter(it => it.type === "slide-up");
  return /*#__PURE__*/jsx(TransitionGroup, {
    component: null,
    children: dialogs.map(dialog => /*#__PURE__*/jsx(CSSRefTransition, {
      timeout: transitionDurationMs,
      classNames: wrapper,
      children: ref => /*#__PURE__*/jsxs("dialog", {
        ref: ref,
        open: true,
        className: cx(wrapper, dialog.className),
        children: [/*#__PURE__*/jsx(FocusOn, {
          onEscapeKey: () => dialog.onSelect(undefined),
          onClickOutside: () => dialog.onSelect(undefined),
          autoFocus: true,
          returnFocus: true,
          focusLock: true,
          scrollLock: true,
          allowPinchZoom: true,
          preventScrollOnFocus: true,
          children: /*#__PURE__*/jsxs("div", {
            className: content,
            children: [/*#__PURE__*/jsx("h1", {
              className: heading,
              children: dialog.heading
            }), /*#__PURE__*/jsx("div", {
              className: body,
              children: dialog.body
            }), /*#__PURE__*/jsx(Actions, {
              actions: dialog.actions,
              onSelect: dialog.onSelect
            }), /*#__PURE__*/jsx(CloseButton, {
              label: "Luk dialog",
              onClose: () => dialog.onSelect(undefined)
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: backdrop
        })]
      })
    }, dialog.id))
  });
}
function Actions(props) {
  return /*#__PURE__*/jsx("ul", {
    className: actionsList,
    children: props.actions.map((action, index) => /*#__PURE__*/jsx("li", {
      children: "href" in action ? /*#__PURE__*/jsx(Link, {
        href: action.href,
        theme: action.type,
        onClick: () => props.onSelect(undefined),
        children: action.label
      }) : /*#__PURE__*/jsx(Button, {
        theme: action.type,
        onClick: () => props.onSelect(action.intent),
        children: action.label
      })
    }, index))
  });
}

export { CourseBuilderPanelNotifier };
//# sourceMappingURL=integration.notifier.js.map
